import { CddEmbeddedFields } from '../../../eddQuestions/pages/direct/field.types';
import { CddVolumesQuestion } from '../../common/CddVolumesQuestion';
import type { CddInternationalWiresVolumesFormContentKeys } from '../../common/cddVolumesForm.types';

export const CddInternationalWiresVolumesForm = ({
  contentKeys,
}: {
  contentKeys: CddInternationalWiresVolumesFormContentKeys;
}) => (
  <div>
    <CddVolumesQuestion
      sectionKey='internationalWireVolumes'
      fieldName={CddEmbeddedFields.CDD_INTERNATIONAL_WIRES_VOLUMES_INCOMING}
      contentKey={contentKeys.internationalWiresIncoming}
    />
    <CddVolumesQuestion
      sectionKey='internationalWireVolumes'
      fieldName={CddEmbeddedFields.CDD_INTERNATIONAL_WIRES_VOLUMES_OUTGOING}
      contentKey={contentKeys.internationalWiresOutgoing}
    />
  </div>
);
